import React from 'react';
import axios from "axios";
import Swal from "sweetalert2";

export default class Welcome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.handleSignin=this.handleSignin.bind(this);
    }

    handleSignin(){
        axios.post('https://spice-api.pearlfall.vercel.app'+`/users/signin`, this.state)
            .then(function (response) {
                // console.log('response', response);
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    componentDidMount() {
        this.handleSignin();
    }
    render() {
        let username = sessionStorage.getItem("username");
        return (
            <React.Fragment>
                <div className="text-center" style={{"paddingTop": "20%"}}>
                <h1>Welcome to Spice {username} ! </h1>
                    <link /> Go to Dashboard
                </div>
            </React.Fragment>

        );
    }
}
